// Vendor libraries
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
// Modules
import { BaseAutocompleteModule } from '../../base-autocomplete/base-autocomplete.module';
import { IconModule } from 'NewAngular/features/directives/icon/icon.module';
import { SecurityListSelectorModalModule } from 'SecurityListsApp/ts/features/security-list-selector-modals/security-list-selector-modal.module';
import { TooltipModule } from 'NewAngular/features/directives/popovers/tooltip/tooltip.module';
import * as i0 from "@angular/core";
export class SecurityAndListAutocompleteInPlaceModule {
}
SecurityAndListAutocompleteInPlaceModule.ɵfac = function SecurityAndListAutocompleteInPlaceModule_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || SecurityAndListAutocompleteInPlaceModule)(); };
SecurityAndListAutocompleteInPlaceModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: SecurityAndListAutocompleteInPlaceModule });
SecurityAndListAutocompleteInPlaceModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [BaseAutocompleteModule,
        CommonModule,
        FormsModule,
        IconModule,
        TooltipModule,
        SecurityListSelectorModalModule] });
